export default __webpack_public_path__ + "static/media/indimg2.27abc554.webp";